const KLARNA_PDP_PRICE_LIMIT = 17000;

module.exports = {
    KLARNA_PDP_PRICE_LIMIT,
};
